module.exports = __webpack_public_path__ + "static/images/saved.2tmXHPY.svg";